import React from 'react';
import PropTypes from 'prop-types';
import { min, max, range, round } from 'lodash';
import 'zingchart/es6';
import ZingChart from 'zingchart-react';
import { KPI_GREEN, KPI_RED, KPI_YELLOW } from './colors';

const GaugeChart = (props) => {
  const stepSize = max(props.intervals) === 1 ? 0.01 : 1;
  const labels = range(min(props.intervals), max(props.intervals), stepSize).map((l) => {
    const intervalValue = round(l, 4);
    return props.intervals.some((v) => v === intervalValue) ? props.intervals.find((v) => v === intervalValue) : '';
  });

  return (
    <div
      style={{
        height: 250,
        width: '100%',
        overflow: 'hidden',
        marginTop: -70,
        position: 'relative',
        zIndex: 1,
      }}
    >
      <ZingChart
        data={{
          type: 'gauge',
          plotarea: {
            adjustLayout: true,
            marginTop: 30,
            marginLeft: 30,
            marginRight: 30,
          },
          plot: {
            size: '100%',
          },
          scaleR: {
            itemsOverlap: true,
            maxItems: labels.length * 2,
            aperture: 180,
            center: {
              visible: false,
            },
            item: {
              offsetR: 0,
            },
            labels: labels,
            maxValue: max(props.intervals),
            minValue: min(props.intervals),
            ring: {
              rules:
                props.rules ||
                props.intervals.slice(0, 3).map((interval, index) => ({
                  backgroundColor: (props.reverseColors
                    ? [KPI_GREEN, KPI_YELLOW, KPI_RED]
                    : [KPI_RED, KPI_YELLOW, KPI_GREEN])[index],
                  rule: index === 2 ? `%v >= ${interval}` : `%v >= ${interval} && %v < ${props.intervals[index + 1]}`,
                })),
              size: '30px',
            },
            step: stepSize,
            tick: {
              visible: false,
            },
          },
          tooltip: {
            borderRadius: '5px',
          },
          series: [
            {
              values: [
                props.value < min(props.intervals)
                  ? min(props.intervals)
                  : props.value > max(props.intervals)
                  ? max(props.intervals)
                  : props.value,
              ], // starting value
              backgroundColor: 'black',
              indicator: [7, 7, 7, 7, 0.8],
              animation: {
                effect: 'ANIMATION_EXPAND_VERTICAL',
                method: 'ANIMATION_BACK_EASE_OUT',
                sequence: 'null',
                speed: 900,
              },
            },
          ],
        }}
      />
    </div>
  );
};

GaugeChart.propTypes = {
  value: PropTypes.number,
  reverseColors: PropTypes.bool,
  intervals: PropTypes.array.isRequired,
  rules: PropTypes.arrayOf(
    PropTypes.shape({
      rule: PropTypes.string.isRequired,
      backgroundColor: PropTypes.string.isRequired,
    })
  ),
};

GaugeChart.defaultProps = {
  value: 0,
  reverseColors: false,
};

export default GaugeChart;
